import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex gap-2 mb-2 overflow-x-auto wallet-badges-row mx-[34px]"
}
const _hoisted_2 = ["onClick"]

import { PropType, computed } from 'vue';
import { Wallet } from '@/shared/interfaces/balance';
import useUtils from '@/shared/composables/useUtils';


export default /*@__PURE__*/_defineComponent({
  __name: 'WalletBadges',
  props: {
	wallets: { type: Array as PropType<Wallet[]>, default: () => [] },
	selectedWallet: { type: Object as PropType<Wallet | undefined>, default: undefined },
},
  emits: ['select'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { convertToCurrency } = useUtils();

const activeWallets = computed(() => props.wallets.filter((w) => +w.current_balance > 0));

return (_ctx: any,_cache: any) => {
  return (activeWallets.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeWallets.value, (wallet) => {
          return (_openBlock(), _createElementBlock("div", {
            key: wallet.id,
            class: _normalizeClass(["wallet-badge flex-shrink-0 cursor-pointer", { 'wallet-badge--active': __props.selectedWallet?.id === wallet.id }]),
            onClick: ($event: any) => (emit('select', wallet))
          }, _toDisplayString(wallet.currency.prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+wallet.current_balance)), 11, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})